import React, { FC } from "react";

import { TemplateLabelContainer, TemplateIcon, TemplateLabelText, PopupWithCustomBlank } from "../../styled";

type TemplateLabelProps = {
  type: string;
  img: string;
  text: string;
  isTemplateOpen: boolean;
  toggleTemplate: (type: string) => void;
  width?: string;
};

export const TemplateLabel: FC<TemplateLabelProps> = ({
  type,
  img,
  text,
  width,
  isTemplateOpen,
  toggleTemplate,
  children,
}) => {
  return (
    <PopupWithCustomBlank
      duration={[0, 0]}
      isVisible={isTemplateOpen}
      placement={"bottom-start"}
      onRequestClose={() => toggleTemplate(type)}
      hasContentScroll
      anchor={(ref: (node: HTMLElement) => void) => (
        <TemplateLabelContainer ref={ref} width={width} onClick={() => toggleTemplate(type)}>
          <TemplateIcon img={img} />
          <TemplateLabelText>{text}</TemplateLabelText>
        </TemplateLabelContainer>
      )}
    >
      {children}
    </PopupWithCustomBlank>
  );
};
